export const LogoShort: {
  name: 'logo_short-86835b3d1e14'
} = {
  name: 'logo_short-86835b3d1e14'
}
